/**
 * An id containing this would merge two entities onto one record, serving one at
 * the other's price. {@link containsKeyDelimiter} lets callers reject that.
 */
export const UBER_POS_KEY_DELIMITER = '|';
export const CONTEXT_PREFIX = {
    ITEM: 'item',
    MODIFIER_GROUP: 'mg',
};
/**
 * Suffix the sync appends to every record of a menu whose fulfillment slices
 * diverged, so one Uber menu becomes several Owner menus. Always last in
 * `contextId`, after any parent or suspension scope.
 */
export const FULFILLMENT_CONTEXT = '#ff:';
export const toUberPosKey = ({ menuId, id, contextId }) => [menuId, id, contextId ?? ''].join(UBER_POS_KEY_DELIMITER);
/**
 * Which Owner menu a record belongs to, for an Uber menu split per fulfillment
 * slice. `menuId` alone is ambiguous once a menu is split — every slice keeps
 * Uber's id and is told apart only by this suffix.
 */
export const toUberMenuScope = ({ menuId, contextId }) => {
    const marker = contextId?.indexOf(FULFILLMENT_CONTEXT) ?? -1;
    const slice = marker >= 0 ? (contextId?.slice(marker) ?? '') : '';
    return [menuId, slice].join(UBER_POS_KEY_DELIMITER);
};
/** Null when the override is not keyed on a parent context; `MENU` is absorbed by `menuId`. */
export const toUberContextId = (contextType, contextValue) => {
    if (!contextValue)
        return null;
    if (contextType === 'ITEM')
        return `${CONTEXT_PREFIX.ITEM}:${contextValue}`;
    if (contextType === 'MODIFIER_GROUP')
        return `${CONTEXT_PREFIX.MODIFIER_GROUP}:${contextValue}`;
    return null;
};
export const containsKeyDelimiter = (value) => value.includes(UBER_POS_KEY_DELIMITER);
//# sourceMappingURL=uberPosKey.js.map